export enum PersonalizeType {
  Face = 'face',
  Hair = 'hair', // 只有pc端
  Cloth = 'cloth',
  Action = 'action',
}

export interface ChoseListItem {
  previewMan: string;
  previewWoman: string;
  displayMan: string;
  displayWoman: string;
}

const FaceMatchList: ChoseListItem[] = [
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd35kjn_322435.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd39osv_514574.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgoy_033282.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgoy_033282.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd35kjp_322436.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd39osx_514574.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp0_033283.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp0_033283.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd35kjs_322436.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd39osw_514574.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp1_033283.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp1_033283.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd35kjo_322436.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd39osy_514574.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp2_033283.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp2_033283.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd35kjr_322436.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd39osu_514574.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp3_033283.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgp3_033283.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd35kjq_322436.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd39osz_514574.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgoz_033282.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbxwgoz_033282.png',
  },
];

const ClothMatchList: ChoseListItem[] = [
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmrl_819260.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamq480_795229.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmrf_819259.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbi0_804659.png',
  },

  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbhx_804659.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamq483_795229.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmrg_819259.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbi1_804660.png',
  },

  {
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmrh_819259.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamq47x_795229.png',
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbhw_804659.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamq482_795229.png',
  },

  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbhv_804659.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmri_819259.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamq47y_795229.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamq481_795229.png',
  },

  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbhy_804659.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmrj_819259.png',
    previewMan: ' https://static.fuxi.netease.com/yaotai/portal/index/lgamq47z_795229.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgampy44_787316.png',
  },

  {
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqmrk_819260.png',
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgamqbhz_804659.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgampy45_787317.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgampy46_787317.png',
  },
];

const HairMatchList: ChoseListItem[] = [
  {
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgcbvsd2_516374.png',
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd2l0n0_363516.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgatdmh6_969674.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgauaox3_512487.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd2l0n1_363517.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgcbvsd3_516374.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgatpqw1_535264.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgauaox4_512488.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd2l0n2_363517.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgcbvsd4_516374.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgatpqw2_535264.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgauaox5_512488.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd2l0n3_363517.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgcbvsd5_516374.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgatpqw3_535264.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgauaox6_512488.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd2l0n4_363517.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgcbvsd6_516374.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgatpqw4_535264.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgauaox7_512488.png',
  },
  {
    displayWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgd2l0n5_363517.png',
    displayMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgcbvsd7_516374.png',
    previewMan: 'https://static.fuxi.netease.com/yaotai/portal/index/lgatpqw5_535264.png',
    previewWoman: 'https://static.fuxi.netease.com/yaotai/portal/index/lgauaox8_512488.png',
  },
];

export const VIRTUAL_PERSONALIZE_MAP = {
  [PersonalizeType.Cloth]: {
    title: '百套服装随心选择',
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll4wsdaj_811083.png',
    desc: ['近百款高精度服饰，百变形象缺“衣”不可', '支持服装 Logo 自定义，全方位呈现品牌形象'],
    matchList: ClothMatchList,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lga8680v_352415.mp4',
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgairk05_143877.jpg',
    using: ['pc', 'h5'],
  },
  [PersonalizeType.Hair]: {
    title: '多种发型自由挑选',
    desc: ['20+发型任意挑选，从头开始新形象', '发型库持续更新，不断解锁新惊喜'],
    matchList: HairMatchList,
    thumb: '',
    img: '',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lfvwjwfl_308720.mp4',
    using: ['pc'],
  },

  [PersonalizeType.Face]: {
    title: '虚拟形象千人千面',
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll4wsbkq_808858.png',
    desc: [
      '支持上传真人照片，一秒生成个性化脸部形象，AI 打造数字分身',
      '260+面部维度调整，含五官、脸型和肤色，自由定义虚拟形象',
    ],
    matchList: FaceMatchList,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lga8680w_352415.mp4',
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgaihkf9_677861.png',
    using: ['pc', 'h5'],
  },
  [PersonalizeType.Action]: {
    title: '丰富动作增添乐趣',
    img: 'https://static.fuxi.netease.com/yaotai/portal/index/ll4wsfm2_814090.png',
    desc: [
      '打招呼、比心、鼓掌、吃瓜、磕瓜子等，各类玩法停不下来',
      '支持单人、双人舞蹈动作，元宇宙里也可以随时嗨跳蹦迪',
    ],
    matchList: [], //动作没有交互操作只有视频
    thumb: 'https://static.fuxi.netease.com/yaotai/portal/index/lgc98r2e_082374.png',
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgc94u3r_899686.mp4',
    using: ['pc', 'h5'],
  },
};
